import React from 'react';
import logo from '../assets/MSRWF Logo 1.png'
import styles from './Footer.module.css'

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerContent}>
        <div className={styles.footerTop}>
          <div className={styles.footerBrand}>
            <img src={logo} alt="MSRWF Logo" className={styles.footerLogo} />
            <span className={styles.footerTitle}>Mississippi Roadworker's Foundation</span>
          </div>
          
          <nav className={styles.footerNav}>
            <a href="/home" className={styles.footerLink}>Home</a>
            <a href="/contact" className={styles.footerLink}>Contact</a>
            <a href="/donate" className={styles.footerLink}>Donate</a>
          </nav>
        </div>
        
        <div className={styles.footerDivider}></div>
        
        <p className={styles.footerCopyright}>
          © 2025 Mississippi Roadworker's Foundation. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
